module.exports = "/_next/static/resources/photo-3-77955d1bfd88a194d98f75e6cd793755.jpg";